import { handleActions } from 'redux-actions';

import { FETCH_REVISTAS_AEQUALIS } from '../constants/index';

const initialState = {
  revistas: [],
};

export const revistaAequalis = handleActions(
  {
    [FETCH_REVISTAS_AEQUALIS]: (state, action) => action.payload,
  },
  initialState,
);
